'use client';
import { useGetShowingGoogleOneTapLoginPrompt } from '~/app/_state/showing-google-one-tap-login-prompt-state';
import { IMobileOverlayContainer } from '@app/_containers/i-mobile-overlay-container';
import { MicroAdOverlayContainer } from '@app/_containers/microad-overlay-container';

type Props = {
  canShowGoogleAd: boolean;
};

export const BottomOverlayContainer = ({ canShowGoogleAd }: Props) => {
  const { showingGoogleOneTapLoginPrompt } =
    useGetShowingGoogleOneTapLoginPrompt();

  // when showingGoogleOneTapLoginPrompt is true, we don't show any ad
  if (showingGoogleOneTapLoginPrompt) return null;

  if (canShowGoogleAd) {
    // for normal

    // 95% of the time, we show microad ad
    // const adNetwork = Math.random() < 0.9 ? 'microad' : 'i-mobile';

    // return adNetwork === 'i-mobile' ? (
    //   <IMobileOverlayContainer canShowGoogleAd={canShowGoogleAd} />
    // ) : (
    //   <MicroAdOverlayContainer canShowGoogleAd={canShowGoogleAd} />
    // );
    // NOTE: i-mobileでのGoogle配信の確認のため、i-mobileのオーバーレイ広告を利用する（内部でMicroAdと1:1で配信される）
    // https://linear.app/tellernovel/issue/TN-952/i-mobileのオーバーレイ広告のタグを差し替え
    return <IMobileOverlayContainer canShowGoogleAd={canShowGoogleAd} />;
  } else {
    // for sensitive

    // 95% of the time, we show microad ad
    const adNetwork = Math.random() < 0.5 ? 'microad' : 'i-mobile';

    return adNetwork === 'i-mobile' ? (
      <IMobileOverlayContainer canShowGoogleAd={canShowGoogleAd} />
    ) : (
      <MicroAdOverlayContainer canShowGoogleAd={canShowGoogleAd} />
    );
  }
};
